import { frontendURL } from '../../../helper/URLHelper';
import OperationsOverview from './OperationsOverview.vue';

const operationsPermissions = ['administrator', 'supervisor', 'report_manage'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/operations'),
      name: 'operations_overview',
      meta: { permissions: operationsPermissions },
      component: OperationsOverview,
    },
  ],
};
